import React, { useState, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { api } from '../../../../api';
import {
    Button,
    Input,
    Container,
    Row,
    Col,
    FormGroup,
} from "reactstrap";
import Cookies from 'js-cookie';

const EditMaterialReturn = () => {
    const { id } = useParams();

    console.log('id',id);
    const [updateValue, setupdateValues] = useState({
        return_id: "",
        product_name: "",
        quantity_returned: "",
        yet_to_returned: "",
        return_date: "",
        returned_by: "",
    });

    // console.log('update2',updateValue);

    

    useEffect(() => {
        console.log("Item ID:", id); 
        const company_id = Cookies.get('company_id');
        api.get(`crudReturnStock.php?return_id=${id}&company_id=${company_id}`)
          .then((res) => {
            console.log("API Response:", res.data);
            const product = res.data;
            setupdateValues({  
                return_id: product.return_id,
                product_name: product.product_name,
                quantity_returned: product.quantity_returned,
                yet_to_returned: product.yet_to_returned,
                return_date: product.return_date,
                returned_by: product.returned_by,
              });
              console.log("Set state with:", product);
          })
          .catch((err) => console.log(err));
      }, [id]);
      
      useEffect(() => {
        console.log("Rendered updateValue:", updateValue);
      }, [updateValue]);

      console.log("updateValue:", updateValue); // Add this line
      
      
    

    const handleSubmit = async (event) => {
        event.preventDefault();
    
        try {
            const company_id = Cookies.get('company_id');
            const response = await api.put(`crudReturnStock.php?company_id=${company_id}`, updateValue);
            console.log("Data sent successfully:", response.data);
    
            // Check if the status is 'success' and then navigate back
            if (response.data.status === 'success') {
                window.history.back(); // Navigate back
            } else {
                // Optionally, you can handle other cases like showing an error message
                console.log("Update was not successful:", response.data.message);
            }
        } catch (error) {
            console.error("Error submitting data:", error);
        }
    };
    

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setupdateValues((prevState) => ({
          ...prevState,
          [name]: value,
        }));
      };
    console.log('update',updateValue);

    return (
        <>
            <div className="header bg-gradient-info py-7 py-lg-8">
                <Col className="order-xl-2 mb-5 mb-xl-0 text-center  mb-5">
                    <h1>Edit Material Return</h1>
                </Col>
                <Link to="/store-admin/store-management/Storemanagement4"> <Button className='ml-5' style={{ backgroundColor: '#d86f89', borderColor: '#d86f89', color: 'black' }}>Back</Button></Link>
                <Container className="py-4 ">
                    <div className="p-4 rounded" style={{ boxShadow: '0 4px 8px rgba(0, 0, 0, 0.15)', backgroundColor: '#fff', borderRadius: '15px' }}>
                        <Row className='px-3'>
                            <Col md={12}>
                                <FormGroup>
                                    <label className="form-control-label" htmlFor="input-status">Product Name</label>
                                    <Input
                                        className="form-control-alternative"
                                        id="input-name"
                                        type="text"
                                        name="product_name"
                                        onChange={handleInputChange}
                                        value={updateValue.product_name}
                                    />
                                </FormGroup>
                            </Col>
                            
                            <Col md={12}>
                                <FormGroup>
                                    <label className="form-control-label" htmlFor="input-manager">Quantity Returned</label>
                                    <Input
                                        className="form-control-alternative"
                                        id="input-manager"
                                        type="number"
                                        name='quantity_returned'
                                        onChange={handleInputChange}
                                        value={updateValue.quantity_returned}
                                    />
                                </FormGroup>
                            </Col>
                            <Col md={6}>
                            <FormGroup>
                                <label className="form-control-label" htmlFor="input-ending">Returned By</label>
                                <Input
                                className="form-control-alternative"
                                id="input-ending"
                                type="text"  // <- changed from "number" to "text"
                                name="returned_by"
                                onChange={handleInputChange}
                                value={updateValue.returned_by}
                                />
                            </FormGroup>
                            </Col>
                            <Col md={6}>
                            <FormGroup>
                                <label className="form-control-label" htmlFor="input-ending">Return Date</label>
                                <Input
                                className="form-control-alternative"
                                id="input-ending"
                                type="date" // <- assuming this is a date field
                                name="return_date"
                                onChange={handleInputChange}
                                value={updateValue.return_date}
                                />
                            </FormGroup>
                            </Col>
                            <Col md={6}>
                                <FormGroup>
                                    <label className="form-control-label" htmlFor="input-ending">Yet to Return</label>
                                    <Input
                                        className="form-control-alternative"
                                        id="input-ending"
                                        type="number"
                                        name="yet_to_returned"
                                        onChange={handleInputChange}
                                        value={updateValue.yet_to_returned}
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col lg='12' className='text-center mb-2'>
                                <Button style={{ backgroundColor: '#d86f89', borderColor: '#d86f89', color: 'black' }} type="submit" onClick={handleSubmit}>Submit</Button>
                            </Col>
                        </Row>
                    </div>
                </Container>
            </div>
        </>
    );
};

export default EditMaterialReturn;
